<template>    
    <HomeContents />
</template>

<script>
//메인 관련 css
import HomeContents from "./HomeContents";
// import HomeAcademy from "./HomeAcademy";
export default {
  components: {
    HomeContents,
    // HomeAcademy,
  },
};
</script>



// WEBPACK FOOTER //
// src/components/cowork/general/home/base/Home.vue